import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges, ViewChild
} from "@angular/core";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import * as _ from "lodash";
import * as angular from "angular";
import {Subscription} from "rxjs";
import {BranchesComponentStore} from "../../state/branches-component.store";
import {BranchModel} from "../../../models/branch.model";
import {BranchesMultiSelectListComponent} from "../branches-multi-select-list/branches-multi-select-list.component";

require('./branches-multi-select.scss');
@Component({
  standalone: false,
  selector: 'app-branches-multi-select',
  templateUrl: './branches-multi-select.html',
  providers: [BranchesComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchesMultiSelectComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() branches: BranchModel[];
  @Input() selectedIds: string[];
  @Input() options: BranchModel[];
  @Input() optionIds: string[];
  @Input() ngPlaceholder: any;
  @Input() excludeIds: string[];
  @Input() isDisabled: boolean;
  @Input() isRequired: boolean;
  @Output() onChange = new EventEmitter<any>();

  @ViewChild('inputRef', {static: true}) inputRef: ElementRef;


  public selectedBranches: any;
  public selectedText: any;
  public branchesSubscription: Subscription;
  public sortedOptions: BranchModel[];

  constructor(@Inject(PanelService) private panelService: PanelService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(BranchesComponentStore) private branchesStore: BranchesComponentStore, @Inject('$timeout') private $timeout) {
  }

  ngOnInit() {
    if (!!this.options?.length) {
      this.sortedOptions = [...this.options].sort((b1, b2) => b1.name.localeCompare(b2.name));
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      let currentSelectedIds = _.get(changes.selectedIds, 'currentValue', []),
        previousSelectedIds = _.get(changes.selectedIds, 'previousValue', []),
        idsToRemove: string[] = _.differenceBy(previousSelectedIds, currentSelectedIds),
        idsToAdd: string[] = _.difference(currentSelectedIds, previousSelectedIds);


      if (idsToAdd?.length && !this.options) {
        this.branchesStore.getBranches({ids: idsToAdd});
      }
      if (idsToRemove?.length && !this.options) {
        this.branchesStore.removeBranches(idsToRemove);
      }
      this._setSelectedBranches();

      this.cdr.markForCheck();
    }
  }

  ngAfterViewInit() {
    this._setSelectedBranches();
    this.branchesSubscription = this.branchesStore.vm$.subscribe((vm) => {

      if (!!vm.branches.length) {
        this.selectedBranches = _.orderBy(vm.branches, ['name'], ['asc']);
        this._setSelectedText();
      }
      this.cdr.detectChanges();
    })

  }

  ngOnDestroy() {
    this.branchesStore.onResetBranches();
    this.branchesSubscription.unsubscribe();
  }


  onResetFilter() {
    this.onChange.emit({branchIds: [], branches: []});
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(BranchesMultiSelectListComponent, event, {
      selectedIds: this.selectedIds,
      excludeIds: this.excludeIds,
      options: !!this.options ? this.sortedOptions : undefined
    })

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        this.onChange.emit({branchIds: data?.branchIds || this.selectedIds});

        // this.$timeout(0).then(() => {
        // });
      })
    }
  }

  private _setSelectedBranches() {
    if (!!this.branches) {
      this.selectedBranches = angular.copy(this.branches);
    } else if (!!this.selectedIds?.length) {
      if (!!this.options) {
        // this.selectedBranches = _.filter(this.options, (o) => {
        //   return _.includes(this.selectedIds, o.id);
        // });

        this.selectedBranches = this.options.filter((o: BranchModel) => this.selectedIds.includes(o.id));
      } else {
        this.branchesStore.getBranches({ids: this.selectedIds});
      }

    } else {
      this.selectedBranches = [];
    }

    this._setSelectedText();
  }

  private _setSelectedText() {
    if (!this.selectedBranches?.length) {
      this.selectedText = '';
      return;
    }

    let string = this.selectedBranches.map(b => b.name).join(', ');

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");
    const inputWidth = this.inputRef?.nativeElement?.clientWidth;

    if (!ctx || !inputWidth) return;
    const textWidth = ctx.measureText(string).width;

    if (inputWidth - 50 < textWidth) {
      string = `${this.selectedBranches[0].name}`;

      if (this.selectedBranches.length - 1 > 0) {
        string == ` +${this.selectedBranches.length - 1}`;
      }

    }
    this.selectedText = string;
  }


}
